export default {
    name: "SLINE DISPUTE DASHBOARD",
    path: "/slineApprovalList",
    meta: {
        icon: "speaker_notes",
        auth: true
    },
    departmentName: "SLINE DISPUTE DASHBOARD",
    finalPagePermision: "SLINE DISPUTE DASHBOARD",

    component: require("../component/payment/SlineApprovalList.vue")
};


// WEBPACK FOOTER //
// ./src/sidebar/disputeSlineDash.js